import { render, staticRenderFns } from "./pedidoMobile.vue?vue&type=template&id=8fd78c58&scoped=true&"
import script from "./pedidoMobile.vue?vue&type=script&lang=js&"
export * from "./pedidoMobile.vue?vue&type=script&lang=js&"
import style0 from "./pedidoMobile.vue?vue&type=style&index=0&id=8fd78c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd78c58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataIterator } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VAlert,VAutocomplete,VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataIterator,VDialog,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VLayout,VList,VListTile,VListTileContent,VSelect,VSpacer,VSubheader,VTextField,VTextarea})
